// axios를 이용하는 http 통신을 한곳에서 관리하기 위함
import axios from 'axios'

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL, // 기본 API URL
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // 쿠키 포함
  timeout: 0, // 일정시간이 지나면 에러로 간주(제한없음 = 0)
})

// 요청시 토큰 자동 추가
axiosInstance.interceptors.request.use(
  (req) => {
    return req
  },
  (error) => Promise.reject(error)
)

axiosInstance.interceptors.response.use(
  (res) => res,
  async (err) => {
    return Promise.reject(err)
  }
)

export default axiosInstance
